import { getEmbedCode, getVideoDetails } from '../../utils/video-helpers'

const EmbeddedVideo = (function () {
  const selector = '.js-video-embed'
  const elements = document.querySelectorAll(selector)

  const initVideoEmbeds = () => {
    elements.forEach((videoEl) => {
      const videoUrl = videoEl.dataset.url
      const videoTitle = videoEl.dataset.title
      if (!!videoUrl) {
        const videoDetails = getVideoDetails(videoUrl)
        const embedCode = getEmbedCode(videoTitle, videoDetails.id, videoDetails.service)
        videoEl.appendChild(embedCode)
      }
    })
  }

  return {
    init: () => {
      initVideoEmbeds()
    },
  }
})()

export default EmbeddedVideo
